export const RESET_PASSWORD_INIT_ACTION =
  "RESET_PASSWORD_INIT_ACTION";
export const RESET_PASSWORD_SUCCESS_ACTION =
  RESET_PASSWORD_INIT_ACTION + "_SUCCESS";
export const RESET_PASSWORD_FAIL_ACTION =
  RESET_PASSWORD_INIT_ACTION + "_ERROR";

